import React from 'react';
import { KKP_DISTRIB_PALETTE } from '../../utils/kkpDistribPalette';
import '../../styles/kkp-distrib-page.scss';

const KkpDistribColorPicker = ({ value, onChange, disabled = false }) => {
  return (
    <div className="kkp-distrib-swatches" role="group" aria-label="Couleur de surlignage">
      <button
        type="button"
        className={`kkp-distrib-swatch kkp-distrib-swatch--none ${!value ? 'is-active' : ''}`}
        title="Aucune"
        aria-label="Aucune couleur"
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          onChange(null);
        }}
      />
      {KKP_DISTRIB_PALETTE.map((color) => (
        <button
          key={color.key}
          type="button"
          className={`kkp-distrib-swatch ${value === color.key ? 'is-active' : ''}`}
          style={{ backgroundColor: color.hex }}
          title={color.cible === 'nom' ? `${color.label} · nom` : `${color.label} · commentaire`}
          aria-label={color.cible === 'nom' ? `${color.label} (nom)` : `${color.label} (commentaire)`}
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onChange(color.key);
          }}
        />
      ))}
    </div>
  );
};

export default KkpDistribColorPicker;
